import * as React from "react"
import styles from "./FileUploadIcon.module.scss"

interface IProps {
	className?: string
}

const FileUploadIcon: React.FC<IProps> = (props) => {
	return (
		<div className={`${styles.file_upload_icon} ${props.className || ""}`}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M13.4682 2.8876C14.538 2.77464 15.6311 3.04951 16.4509 3.52278C17.2706 3.99604 18.0552 4.80529 18.4923 5.78827C18.9415 6.7985 19.0376 8.04234 18.348 9.23688L13.848 17.0311C13.6013 17.4584 13.1213 18.0101 12.4212 18.3254C11.6637 18.6666 10.725 18.6921 9.74989 18.1292C8.77482 17.5662 8.32757 16.7404 8.24429 15.9139C8.1673 15.1499 8.40514 14.4584 8.65181 14.0311L12.6518 7.1029C12.928 6.62461 13.5395 6.46073 14.0178 6.73688C14.4961 7.01302 14.66 7.62461 14.3839 8.1029L10.3839 15.0311C10.2972 15.1812 10.2083 15.4557 10.2342 15.7134C10.2539 15.9085 10.3393 16.1601 10.7499 16.3971C11.1605 16.6342 11.421 16.5824 11.5999 16.5018C11.836 16.3955 12.0293 16.1812 12.1159 16.0311L16.6159 8.23688C16.9263 7.69936 16.9064 7.14416 16.6648 6.60087C16.4111 6.03033 15.9302 5.53156 15.4509 5.25483C14.9715 4.97809 14.2991 4.81098 13.6782 4.87654C13.0869 4.93898 12.5961 5.19936 12.2858 5.73688L7.28579 14.3971C6.63146 15.5305 7.00005 17.6963 9.24989 18.9952C11.4997 20.2942 13.5597 19.5305 14.214 18.3971L17.714 12.335C17.9901 11.8567 18.6017 11.6928 19.08 11.9689C19.5583 12.2451 19.7222 12.8567 19.446 13.335L15.946 19.3971C14.6004 21.7279 11.1962 22.4283 8.24989 20.7273C5.30358 19.0262 4.20806 15.7279 5.55374 13.3971L10.5537 4.73688C11.2434 3.54234 12.3687 3.00369 13.4682 2.8876Z"
					fill="#959595"
				/>
			</svg>
		</div>
	)
}

export default React.memo(FileUploadIcon)
